import React, { Component } from 'react';
import {ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import KeyboardArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import TrashIcon from 'material-ui/svg-icons/action/delete';
import { CSSTransitionGroup } from 'react-transition-group';

import theme from '../../../muiTheme.js';

import './FilterItemContainer.css';

class FilterItemContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {expanded: props.expanded};
  }

  handleChange = (value) => {
    this.setState({
      expanded: !this.state.expanded
    });
  };



  render() {
    const {expanded} = this.state;
    const children = (expanded) ? this.props.children : '';

    const filterItemStyle = {
      color: (expanded ? theme.palette.canvasColor : theme.palette.secondaryTextColor)
    };

    let trashIcon;
    if (this.props.filter) {
      trashIcon = (
        <TrashIcon
          className="filter-item-header-clear"
          color={filterItemStyle.color}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.onClear()
          }}
          style={{width: "20px", height: "20px"}} />
      )
    }
    const icons = (
      <div className="filter-item-header-icon-container">
        {trashIcon}
        <KeyboardArrowUp className="filter-item-header-arrow" color={filterItemStyle.color} />
      </div>
    )

    return (
      <div className={"filter-item-container" + (expanded ? " filter-item-expanded" : "")}>
        <ListItem
          className={"filter-item-header" + (this.props.filter ? " filter-item-header-filtered" : "")}
          style={filterItemStyle}
          primaryText={this.props.label}
          rightIcon={icons}
          onClick={this.handleChange}
          />
          <CSSTransitionGroup
            transitionName="filter-transition"
            transitionEnterTimeout={325}
            transitionLeaveTimeout={325} >
            {children}
          </CSSTransitionGroup>

        <Divider style={{backgroundColor: "#323232"}} />
      </div>


    )
  }

}

export default FilterItemContainer;
